import { cn } from '../../lib/utils';

export function Progress({ value = 0, max = 100, className, color = 'bg-accent' }) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className={cn('w-full h-1.5 bg-sunken rounded-full overflow-hidden', className)}>
      <div
        className={cn('h-full rounded-full transition-[width] duration-500 ease-out-quart', color)}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
